<template>
  <page-wrapper :title="title">
    <div class="header">
      <div class="container">
        <sc-button
          class="create-button"
          variant="primary"
          :route="createRoute"
        >เพิ่มสถาบันการเงิน</sc-button>
      </div>
    </div>
    <div class="container">
      <financial-institution-list-item
        v-for="item in financialInstitutionList"
        :key="item.id"
        v-bind="item"
      ></financial-institution-list-item>
    </div>
  </page-wrapper>
</template>

<script>
import Vue from "vue";
import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import FinancialInstitutionListItem from "../components/FinancialInstitutionListItem";

export default Vue.extend({
  components: {
    PageWrapper,
    ScButton,
    FinancialInstitutionListItem
  },
  data() {
    const title = "รายการสถาบันการเงิน";
    const createRoute = { name: "FinancialInstitutionCreatePage" };
    const financialInstitutionList = [];

    return { title, createRoute, financialInstitutionList };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const financialInstitutionList = await this.fetchList();

      this.financialInstitutionList = financialInstitutionList.map(item => {
        const { id, name, code } = item;
        const route = { name: "FinancialInstitutionDetailPage", params: { id } };

        return { id, name, code, route };
      })
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.financialInstitution.list();

      return response.data.result;
    }
  }
});
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: ($space / 2) $space;
}

.header {
  padding: 30px;
  border-bottom: $border;

  background: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/features/financial-institutions/pages/FinancialInstitutionListPage.vue